import { IDirectDebitState } from '@modules/checkout-store/reducers/direct-debit';
import { directDebitIsValid } from '@modules/checkout-store/util';
import { createSelector } from '@ngrx/store';
import { IDirectDebitBankDetails, LoadState } from '@nx-ng/types';
import { ApiError, DDAccountVerifyResponse } from '../../client/src';
import { getCheckoutFeatureState, ICheckoutFeatureState } from '../../reducers';
import { mapDirectDebitBankDetails } from '../../util/map-bank-details';

export const selectDirectDebitState = createSelector(
  getCheckoutFeatureState,
  (state: ICheckoutFeatureState) => state?.directDebit
);

export const selectDirectDebitError = createSelector(
  selectDirectDebitState,
  (state: IDirectDebitState | undefined) => state?.error
);

export const selectDirectDebitResponse = createSelector(
  selectDirectDebitState,
  (state: IDirectDebitState | undefined) => state?.directDebitResponse
);

export const selectDirectDebitIsValid = createSelector(
  selectDirectDebitResponse,
  selectDirectDebitError,

  (
    directDebitResponse: DDAccountVerifyResponse | undefined,
    error: string | ApiError | undefined
  ): boolean | undefined => directDebitIsValid({ directDebitResponse, error })
);

export const selectBankDetails = createSelector(
  selectDirectDebitResponse,
  (
    directDebitResponse: DDAccountVerifyResponse | undefined
  ): IDirectDebitBankDetails | undefined => {
    return mapDirectDebitBankDetails(directDebitResponse);
  }
);

export const selectVerifyInProgress = createSelector(
  selectDirectDebitState,
  (state: IDirectDebitState) => state?.loaded === LoadState.LOADING
);

export const selectDirectDebitForm = createSelector(
  selectDirectDebitState,
  (state: IDirectDebitState) => state?.directDebitForm
);
